import { graphql, useStaticQuery } from "gatsby"
import routes from "../common/routes.json"

const useLinksTo = () => {
  const { blog, portfolio } = useStaticQuery(graphql`
    query GetLinksTo {
      blog: contentfulPage(contentful_id: { eq: "6g9yeRSHe33VsSoVUb6ux" }) {
        slug
      }
      portfolio: contentfulPage(
        contentful_id: { eq: "1sDLneEeo9bEBPEU2w0QbR" }
      ) {
        slug
      }
    }
  `)

  const getPageTo = slug => `/${slug}`

  const blogTo = getPageTo(blog.slug)
  const getBlogCategoryTo = categorySlug =>
    `${blogTo}/${routes.categories}/${categorySlug}`
  const getPostLinkTo = postSlug => `${blogTo}/${postSlug}`

  const portfolioTo = getPageTo(portfolio.slug)
  const getPortfolioCategoryTo = categorySlug =>
    `${portfolioTo}/${routes.categories}/${categorySlug}`
  const getCaseStoryLinkTo = caseStorySlug => `${portfolioTo}/${caseStorySlug}`

  return {
    blogTo,
    portfolioTo,
    getPageTo,
    getBlogCategoryTo,
    getPostLinkTo,
    getPortfolioCategoryTo,
    getCaseStoryLinkTo,
  }
}

export default useLinksTo
